import OrderItemsTypeChecksList from './OrderItemsTypeChecksList'

export default {
  list: OrderItemsTypeChecksList,
}
